import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.834 1.513v2.754c0 .373 0 .56.072.702a.67.67 0 0 0 .292.292c.142.072.329.072.702.072h2.754m-3.82 6h-4m5.333-2.666H3.834m8-2.008v4.808c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H4.367c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V4.533c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h2.141c.49 0 .734 0 .964.056a2 2 0 0 1 .578.239c.202.124.375.297.72.643l2.126 2.125c.346.346.52.519.643.72a2 2 0 0 1 .24.579c.055.23.055.475.055.964"
    }, null, -1)
  ]))]))
}
export default { render: render }